import React from "react"
import { Form, Card, Button } from "react-bootstrap"

export default ({
  title = "Talk to us",
  lead = null,
  hideSubject = false,
  hideMessage = false,
  subjectValue = "",
}) => (
  <Card className="shadow-sm">
    <Card.Body>
      <h2>{title}</h2>
      <p>
        {!!lead
          ? lead
          : "We can't wait to talk cloud with you. Just fill out the form and we will be in contact shortly."}
      </p>
      <Form
        name="contact"
        method="post"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
      >
        <input type="hidden" name="form-name" value="contact" />
        <Form.Group controlId="formBasicEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            name="email"
            type="email"
            placeholder="Enter email"
            required
          />
        </Form.Group>
        {!hideSubject && (
          <Form.Group
            controlId="formBasiSubject"
            className={hideSubject && "d-none"}
          >
            <Form.Label>Subject</Form.Label>
            <Form.Control
              name="subject"
              type="text"
              placeholder="What do you want to talk about?"
              value={subjectValue}
              required
            />
          </Form.Group>
        )}
        {!hideMessage && (
          <Form.Group controlId="formBasicMessage">
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              name="message"
              type="textarea"
              rows={3}
              placeholder="Enter your message"
              required
            />
          </Form.Group>
        )}

        <Button variant="primary" type="submit">
          Submit
        </Button>
      </Form>
    </Card.Body>
  </Card>
)
